module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_nordland_pos.6c3fbe7f.pdf";